import styled from "styled-components";

export const StyledCookieMessage = styled.div`
  font-family: ${props => props.theme.typography.sansFamily};
  /* SubtleBlack token */
  background: #353535;
  /* SiteFooterMessageShaow token */
  box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.15);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  padding: 1.5rem;

  @media screen and (max-width: 420px) {
    flex-direction: column;
  }

  a {
    color: #ffffff;
  }

  .cookie-message__button {
    font-family: ${props => props.theme.typography.sansFamily};
    background-color: #616161;
    color: #ffffff;
    border: 0;
    border-radius: 3px;
    padding: 0.6rem 1rem;
    font-size: 1rem;
  }

  .cookie-message__body {
    padding: 1rem;
    text-align: center;
    max-width: 700px;
  }
`;
